import merge from 'lodash/merge';

export type CondKey<T extends object, K> = K extends keyof T ? T[K] : undefined;

export type DeepMerge<T1, T2> = T1 extends Array<unknown>
  ? T2 extends Array<unknown>
    ? Array<DeepMerge<T1[number], T2[number]>>
    : T1
  : T1 extends object
  ? T2 extends object
    ? {
        [K in keyof T1 | keyof T2]: DeepMerge<CondKey<T1, K>, CondKey<T2, K>>;
      }
    : T1
  : T2 extends undefined
  ? T1
  : T2;

export function deepMerge<T1, T2>(obj1: T1, obj2: T2) {
  return merge({}, obj1, obj2) as DeepMerge<T1, T2>;
}

export function prop<Obj extends object, K extends keyof Obj>(k: K): (obj: Obj) => Obj[K] {
  return (obj: Obj) => obj[k];
}

export function flat1<T>(array: T[][]): T[] {
  const res: T[] = [];
  for (const arr of array) {
    for (const val of arr) {
      res.push(val);
    }
  }
  return res;
}

// export type Getter<K extends string | number | Symbol> = <Obj extends object>(
//   obj: Obj,
// ) => K extends keyof Obj ? Obj[K] : undefined;
//
// export type PropGetterFactory = {
//   [K in string]: Getter<K>;
// };
//
// const P: PropGetterFactory = new Proxy(
//   {},
//   {
//     get(_, p: string): unknown {
//       // eslint-disable-next-line @typescript-eslint/no-explicit-any
//       return (obj: any) => obj[p];
//     },
//   },
// );
//
// const abc = [{aaa: 1}, {aaa: 2}];
// console.log(abc.map(P.aaa));
